export default __webpack_public_path__ + "static/media/icon_story_5.a64e613e.svg";